import React, { ReactNode } from 'react';
import { Text } from '../components/Typography';

export interface SidebarSectionProps {
  title?: string;
  children: ReactNode;
  className?: string;
}

export const SidebarSection: React.FC<SidebarSectionProps> = ({
  title,
  children,
  className = '',
}) => {
  return (
    <div className={`p-4 ${className}`}>
      {title && (
        <Text size="xs" weight="medium" color="muted" className="mb-3 uppercase">
          {title}
        </Text>
      )}
      <div className="space-y-1">{children}</div>
    </div>
  );
};
